(() => {
  const BRAND_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0764/5043/1205/files/lbc-premium-logo-wordmark.jpg?v=1783582705';
  const BRAND_NAME = 'Lucknow Best Chikankari';
  const GENERIC_SOCIAL_LINKS = new Set([
    'http://instagram.com',
    'https://instagram.com',
    'http://www.instagram.com',
    'https://www.instagram.com',
    'https://tiktok.com/',
    'http://tiktok.com/',
    'https://www.tiktok.com/',
    'http://www.tiktok.com/',
    'x.com',
    'https://x.com',
    'http://x.com',
    'pinterest.com',
    'https://pinterest.com',
    'http://pinterest.com'
  ]);

  const normalizeHref = (href) => (href || '').trim().replace(/\/$/, '');

  const enhanceHeaderLogo = () => {
    const logoLink = document.querySelector('.header__heading-link');
    if (!logoLink) return;

    const currentImg = logoLink.querySelector('img');
    if (currentImg) {
      const currentSrc = currentImg.getAttribute('src') || '';
      const isMissingOrOld = !currentSrc || !currentSrc.includes('lbc-premium-logo-wordmark');
      if (isMissingOrOld) currentImg.src = BRAND_LOGO_URL;
      currentImg.alt = BRAND_NAME;
      currentImg.loading = 'eager';
      return;
    }

    const fallbackText = logoLink.textContent ? logoLink.textContent.trim() : '';
    if (fallbackText && fallbackText.toLowerCase().includes('lucknow')) return;

    logoLink.setAttribute('aria-label', BRAND_NAME);
    const img = document.createElement('img');
    img.className = 'lbc-injected-logo';
    img.src = BRAND_LOGO_URL;
    img.alt = BRAND_NAME;
    img.width = 1200;
    img.height = 300;
    img.loading = 'eager';
    logoLink.appendChild(img);
  };

  document.addEventListener('DOMContentLoaded', () => {
    enhanceHeaderLogo();

    document.querySelectorAll('a[href]').forEach((link) => {
      const rawHref = link.getAttribute('href') || '';
      const normalized = normalizeHref(rawHref);

      if (GENERIC_SOCIAL_LINKS.has(rawHref.trim()) || GENERIC_SOCIAL_LINKS.has(normalized)) {
        const listItem = link.closest('li');
        if (listItem) listItem.hidden = true;
        else link.hidden = true;
      }

      if (rawHref.includes('/blogs/news/%E2%9C%A8') || rawHref.includes('/blogs/news/✨-discover')) {
        link.setAttribute('href', '/blogs/news');
      }
    });

    document.querySelectorAll('.footer-block__newsletter').forEach((block) => {
      if (block.querySelector('.lbc-newsletter-code')) return;
      const note = document.createElement('p');
      note.className = 'lbc-newsletter-code';
      note.innerHTML = 'Use code <strong>WELCOME10</strong> at checkout for 10% off your first order.';
      block.appendChild(note);
    });
  }, { once: true });
})();